import { render, staticRenderFns } from "./empty-view.vue?vue&type=template&id=5a893f30&scoped=true"
import script from "./empty-view.vue?vue&type=script&lang=js"
export * from "./empty-view.vue?vue&type=script&lang=js"
import style0 from "./empty-view.vue?vue&type=style&index=0&id=5a893f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a893f30",
  null
  
)

export default component.exports